import { createAction } from '@reduxjs/toolkit';
import { CountShowingAdultBanner } from '@store/initiation/features/count-showing-adult-banner/count-showing-adult-banner';
import { StartInternetConnectionStateChangeWatcher } from '@store/internet/internet-connection-check/start-internet-connection-state-change-watcher';
import { GetLanguages } from '@store/languages/features/get-languages/get-languages';
import { RefreshTopicGeneratorUses } from '@store/openAI/features/topic-generator-uses/refresh-topic-generator-uses';
import { GetProfile } from '@store/profile/features/get-profile/get-profile';
import { GetUserTheme } from '@store/profile/features/get-user-theme/get-user-theme';
import { GetCurrentUserBot } from '@store/user-bots/features/get-current-user-bot/get-current-user-bot';
import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

export class AppInit {
  static get action() {
    return createAction('INIT');
  }

  static get saga() {
    return function* (): SagaIterator {
      yield put(GetUserTheme.action());
      yield put(GetProfile.action({}));
      yield call(StartInternetConnectionStateChangeWatcher.saga);
      yield put(GetLanguages.action());
      yield put(RefreshTopicGeneratorUses.action());
      yield put(GetCurrentUserBot.action({}));
      yield put(CountShowingAdultBanner.action());
    };
  }
}
